// S3 PutObjectTagging replaces the whole tag set, so updating a few tags means sending
// the existing ones back as well. Every value goes out as a string: a tag the Cloud did
// not write itself (the archive line's ambifi-lifecycle tag, skipIndexing from the sync
// scripts) used to be carried over as the whole {Key, Value} object, and the SDK then
// refused the entire write — which showed up as "Unable to lock activity for editing".
export function mergeObjectTags(existingTags, tags) {
	const merged = new Map();
	const asString = value => (value === undefined || value === null ? "" : String(value));
	(Array.isArray(existingTags) ? existingTags : []).forEach(tag => {
		if (tag && typeof tag.Key === "string") {
			merged.set(tag.Key, asString(tag.Value));
		}
	});
	Object.keys(tags || {}).forEach(key => {
		merged.set(key, asString(tags[key]));
	});
	return Array.from(merged, ([Key, Value]) => ({ Key, Value }));
}
